/** Capture the current game view as a small JPEG (for chats and posts). */
export function snapshot(maxW = 260): string {
  const src = document.getElementById('cv') as HTMLCanvasElement | null;
  if (!src) return '';
  const k = Math.min(1, maxW / src.width);
  const cv = document.createElement('canvas');
  cv.width = Math.round(src.width * k);
  cv.height = Math.round(Math.min(src.height, src.width * 1.1) * k);
  const c = cv.getContext('2d')!;
  // Centre crop around the player (the middle of the screen).
  const sy = Math.max(0, (src.height - cv.height / k) / 2);
  c.drawImage(src, 0, sy, src.width, cv.height / k, 0, 0, cv.width, cv.height);
  return cv.toDataURL('image/jpeg', 0.82);
}

/** Read an image file the player picked and shrink it to a data URL. */
export function readImage(file: File, maxW = 320): Promise<string> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const k = Math.min(1, maxW / img.width);
      const cv = document.createElement('canvas');
      cv.width = Math.round(img.width * k);
      cv.height = Math.round(img.height * k);
      cv.getContext('2d')!.drawImage(img, 0, 0, cv.width, cv.height);
      URL.revokeObjectURL(url);
      resolve(cv.toDataURL('image/jpeg', 0.8));
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('bad image'));
    };
    img.src = url;
  });
}

/** Ask the player for an image file. */
export function pickImage(): Promise<string | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = () => {
      const f = input.files?.[0];
      if (!f) return resolve(null);
      readImage(f).then(resolve, () => resolve(null));
    };
    input.click();
  });
}
